module.exports = __webpack_public_path__ + "static/img/5areaB_9.4ce8ed0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_9.png
// module id = 1210
// module chunks = 1